export default __webpack_public_path__ + "static/media/basketball.bdd3539a.png";